import { Reducer } from "redux";

import { ResendFaxResponse } from "../models/Api/Document";
import { ResendFaxFileDispatchTypes } from "../models/DispatchTypes/Document";
import { ResendFaxFileActionDispatchTypes } from "../constants/Document";

const initialState: ResendFaxResponse = {
  loading: false,
  response: {
    referenceId: 0,
    faxToNumber: "",
    faxBlobId: 0,
    faxToName: "",
    faxFrom: "",
    faxFromName: "",
    faxStatus: "",
    userCreated: ""
  },
  error: null,
};

const ResendFaxReducer: Reducer<
    ResendFaxResponse,
    ResendFaxFileDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ResendFaxFileActionDispatchTypes.POST_RESEND_FAX_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ResendFaxFileActionDispatchTypes.POST_RESEND_FAX_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case ResendFaxFileActionDispatchTypes.POST_RESEND_FAX_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
    case ResendFaxFileActionDispatchTypes.POST_RESEND_FAX_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ResendFaxReducer;
